import { createApp } from "vue";
import { fetchWpApi } from "../common/functions/fetchWpApi.es6";
import News from "../components/News.vue";

async function initializeVue() {
    const news = await fetchWpApi("news", "_fields=title,date,link&orderby=date&order=desc&per_page=10&page=1");

    createApp(News, { datas: news.datas, totalPage: news.totalPage }).mount("#news");
}

initializeVue();
